import { Component, OnInit } from "@angular/core";
import { FeatureViews } from "src/app/ui/models/domains/features/custom-feature-views";
import { PageViews } from "src/app/ui/models/domains/features/custom-page-views";
import { FeatureViewService } from "src/app/ui/services/feature-view.service";
import { BeneficiaryService } from "src/app/ui/services/pbm/beneficiary.service";
import { FileBeneficiary } from "src/app/ui/models/domains/pbm/Beneficiary/file-beneficiary";
import { LoadingService } from "src/app/ui/services/loading.service";
import { CompanyService } from "src/app/ui/services/pbm/company.service";
import { Company } from "src/app/ui/models/domains/pbm/companies/company";
import { MaskInput } from "src/app/ui/models/domains/masks/mask.model";
import { Toast } from "../../../toast/toast";
import { UserService } from "src/app/ui/services/user.service";
import { environment } from "src/environments/environment";
import { AppContext } from "src/app/ui/contexts/app-context";
import { PageableResult } from "src/app/ui/models/domains/paginator/pageable-result";
import { PagingRequest } from "src/app/ui/models/domains/paginator/paging-request";
import { UntypedFormControl } from "@angular/forms";
import { ICompanyFilterParams } from "src/app/ui/models/domains/pbm/companies/company-filter-params";
import { ExportInfoDialogComponent } from "./export-info-dialog/export-info-dialog.component";
import { AsyncImportStatus } from "src/app/ui/models/domains/pbm/async-import/async-import-status";
import { AsyncImportService } from "src/app/ui/services/pbm/async-import-service";
import { FiscalNumber } from "src/app/ui/models/domains/pbm/fiscal-number";
import { MatDialog } from "@angular/material/dialog";

@Component({
  selector: "app-registration-beneficiaries",
  templateUrl: "./registration-beneficiaries.component.html",
  styleUrls: ["./registration-beneficiaries.component.scss"],
})
export class RegistrationBeneficiariesComponent implements OnInit {
  fileName: string;
  company: Company;
  filterText: string;
  fileBeneficiary = new FileBeneficiary();
  searchNotFound = false;
  searchActionFired = false;
  fiscalNumberMask = MaskInput.getFicalNumberMask();
  fileLink = environment.beneficiaryTemplateRegisterFileUploadLink;
  searchType: UntypedFormControl;
  private searchCompanyFirst: boolean;
  public companyPageableResult = new PageableResult();
  private userProfile = this.userService.getUserProfile();
  public tabIndex = 0;

  constructor(
    private asyncImportService: AsyncImportService,
    private featureViewService: FeatureViewService,
    private beneficiaryService: BeneficiaryService,
    private loadingService: LoadingService,
    private companyService: CompanyService,
    private toast: Toast,
    private userService: UserService,
    private appContext: AppContext,
    private dialog: MatDialog,
  ) {
    this.searchType = new UntypedFormControl(1);
  }
  lastImportStatus: AsyncImportStatus;
  lastImportedKey: string;

  ngOnInit() {
    this.userProfile = this.userService.getUserProfile();
    if (this.userProfile.getPreferences().getFilterText()) {
      this.searchCompanies(this.userProfile.getPreferences().getFilterText());
    } else {
      this.searchCompanies("");
    }
    this.featureViewService.activeFeatureView(FeatureViews.BeneficiaryRegistrationBeneficiariesFeatureView, PageViews.BeneficiaryPageView);
    this.loadLastUploaded();
  }

  private loadLastUploaded(): void {
    if (!this.company) return;
    this.lastImportStatus = null;
    this.lastImportedKey = null;

    const loadingRef = this.loadingService.beginLoading();
    try {
      this.lastImportedKey = this.asyncImportService.getKey(this.company.getFiscalNumber());
      if (this.lastImportedKey) {
        this.asyncImportService.registerConsult(this.lastImportedKey).subscribe((x) => {
          this.lastImportStatus = x;
          if (x.isFinished()) {
            loadingRef.closeLoading()
          }
        });
      }
    } catch (e) {
      console.log(e);
    } finally {
      loadingRef.closeLoading();
    }
  }

  hasLastImportStatus(): boolean {
    return this.lastImportStatus != null;
  }

  async searchCompany(company: Company) {
    this.lastImportStatus = null;
    this.lastImportedKey = null;
    if (company.getFiscalNumber()) {
      const ref = this.loadingService.beginLoading();
      await this.companyService
        .findCompanyBy(company.getFiscalNumber())
        .then((x) => {
          this.company = x;
          this.fileBeneficiary.setFiscalNumber(company.getFiscalNumber());
          this.searchNotFound = false;
          this.storageSearchPreferences(company.getFiscalNumber());
        })
        .catch((e) => {
          this.company = null;
          this.searchNotFound = true;
          this.toast.showWarningToast(e);
          this.storageSearchPreferences(null);
        })
        .finally(() => {
          this.filterText = "";
          this.loadingService.finishLoading(ref);
          this.loadLastUploaded();
        });
    } else {
      this.company = null;
      this.searchNotFound = true;
      this.filterText = "";
    }
  }

  async getFile(event) {
    const files = event.target.files;
    if (!FileBeneficiary.isCsvExtension(files.item(0))) {
      this.toast.showWarningToast("Insira um arquivo .csv");
    } else {
      const file = files.item(0);
      
      const validationErrors = await this.validateCsvFile(file);
      if (validationErrors.length > 0) {
        this.toast.showWarningToast(
          `Erros encontrados no arquivo CSV:\n${validationErrors.slice(0, 5).join('\n')}` +
          (validationErrors.length > 5 ? `\n... e mais ${validationErrors.length - 5} erros` : '')
        );
        event.target.value = null;
        return;
      }
      
      this.fileName = file.name;
      this.fileBeneficiary.setFile(file);
    }
    event.target.value = null;
  }

  private async validateCsvFile(file: File): Promise<string[]> {
    return new Promise((resolve) => {
      const reader = new FileReader();
      const errors: string[] = [];

      reader.onload = (e: any) => {
        try {
          const csvContent = e.target.result as string;
          const lines = csvContent.split('\n');

          if (lines.length < 2) {
            errors.push('O arquivo CSV está vazio ou não contém dados');
            resolve(errors);
            return;
          }

          for (let i = 1; i < lines.length; i++) {
            const line = lines[i].trim();
            if (!line) continue; 

            if (errors.length >= 20) {
              errors.push('... limite de erros atingido. Corrija os erros acima e tente novamente.');
              break;
            }
          }

          resolve(errors);
        } catch (error) {
          errors.push(`Erro ao processar o arquivo: ${error.message}`);
          resolve(errors);
        }
      };

      reader.onerror = () => {
        errors.push('Erro ao ler o arquivo CSV');
        resolve(errors);
      };

      reader.readAsText(file, 'UTF-8');
    });
  }

  getCompanies(): Array<Company> {
    return this.companyPageableResult.getItems() as Array<Company>;
  }

  async uploadImportBeneficiaiesFile() {
    if (!this.fileBeneficiary || !this.fileBeneficiary.hasFile() || !this.company) return;
    const loadingRef = this.loadingService.beginLoading();

    await this.beneficiaryService
      .importBeneficiary(this.fileBeneficiary, new FiscalNumber(this.company.getFiscalNumber()))
      .then((key) => {
        if (this.lastImportedKey) {
          this.asyncImportService.removeKey(this.asyncImportService.createKey(this.lastImportedKey, this.company.getFiscalNumber()));
        }
        this.asyncImportService.addKey(this.asyncImportService.createKey(key, this.company.getFiscalNumber()));
        loadingRef.closeLoading();
        this.loadLastUploaded();
      })
      .catch((e) => {
        this.toast.showWarningToast(e.error.Data.ErrorMessage);
        loadingRef.closeLoading();
      });
    this.fileName = null;
    this.fileBeneficiary.setFile(null);
  }

  async downloadFile() {
    const loadingRef = this.loadingService.beginLoading();
    await this.asyncImportService.downloadFileSummary(this.lastImportedKey).then((fileData) => {
      try {
        const fileLink = document.createElement("a");
        document.body.appendChild(fileLink);
        const url = window.URL.createObjectURL(fileData);
        fileLink.href = url;
        fileLink.download = "Resumo_Importacao_Beneficiarios.csv";
        fileLink.click();
        this.toast.showSuccessToast("Arquivo .csv exportado com sucesso.");
        this.tabIndex = 1;
      } catch (error) {
        console.log(error);
      } finally {
        loadingRef.closeLoading();
      }
    }).finally(() => {
      loadingRef.closeLoading();
    });
  }

  hasCompany(): boolean {
    return !!this.company;
  }

  onPressEnterSearchCompanies(event): void {
    if (event.key === "Enter") this.searchCompanies(this.filterText);
  }

  searchCompanies(filterText: string) {
    const start = 1;
    const end = this.appContext.getTotalPerPage();
    this.searchCompanyFirst = true;
    this.doSearchCompany(start, end, filterText);
  }

  searchMoreCompanies() {
    this.searchCompanyFirst = false;
    const start = this.companyPageableResult.getEnd() + 1;
    const end = this.appContext.getTotalPerPage();
    this.doSearchCompany(start, end, this.userProfile.getPreferences().getFilterText());
  }

  private doSearchCompany(start: number, end: number, filterText: string): void {
    const ref = this.loadingService.beginLoading();
    const pagingRequest = new PagingRequest();
    pagingRequest.setStart(start);
    pagingRequest.setEnd(end);

    const filterParams: ICompanyFilterParams = {
      filterText: filterText ? filterText.replace(/[./-]/g, "") : "",
    };
    this.companyService
      .searchCompany(filterParams, pagingRequest)
      .then((companyPageableResult) => {
        this.companyPageableResult.setStart(start);
        this.companyPageableResult.setEnd(end);
        this.companyPageableResult.setTotalItems(companyPageableResult.getTotalItems());

        if (this.searchCompanyFirst) {
          this.companyPageableResult.setItems(companyPageableResult.getItems());
        } else {
          this.companyPageableResult.addItems(companyPageableResult.getItems());
        }

        if (companyPageableResult.getItems().length === 1) {
          this.company = companyPageableResult.getItems()[0] as Company;
          this.searchCompany(this.company);
          this.storageSearchPreferences(filterText);
        } else {
          this.company = null;
          this.storageSearchPreferences(null);
        }
      })
      .catch((error) => {
        this.companyPageableResult.setItems(null);
        this.storageSearchPreferences(null);
      })
      .finally(() => {
        this.loadingService.finishLoading(ref);
        this.filterText = "";
      });
  }

  showScrollBottomBtn(): boolean {
    return this.companyPageableResult.getItems().length > 1;
  }

  showMoreCompaniesBtn(): boolean {
    return this.companyPageableResult.getTotalItems() !== this.companyPageableResult.getItems().length && this.companyPageableResult.getItems().length > 1;
  }

  storageSearchPreferences(fiscalNumber): void {
    this.userService.setUserPreferences(fiscalNumber ? fiscalNumber.replace(/[./-]/g, "") : fiscalNumber);
  }

  scrollToLastCompany() {
    const bottom = document.getElementById("bottom");
    bottom.scrollIntoView();
  }

  public openExportInfoModal(): void {
    this.dialog.open(ExportInfoDialogComponent, {
      id: "status-dialog",
      disableClose: true,
      hasBackdrop: true,
      width: "860px",
      height: "300px",
    });
  }
}
